import { AsciiText } from '../framework/AsciiText';
export class ToaAmCf1 {
    constructor(socket, log) {
        this.socket = socket;
        this.standbyMode = false;
        this.volume = 30;
        this.mute = Array(2).fill(false); // 0 = mic mute, 1 = speakerMute
        this.asyncHandlers = [
            {
                name: 'login',
                regExp: /\x80\x20([\s\S]{32})/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x80, 0x01, 0x01]));
                },
            },
            {
                name: 'muteGet',
                regExp: /\xF0\x03\x18([\s\S])\x00/,
                callback: (match) => {
                    const muteIndex = match[1].charCodeAt(0);
                    if (muteIndex < 2) {
                        const mute = this.mute[muteIndex];
                        this.socket.send(this.makeCommand([0x98, 0x03, muteIndex, 0x00, mute ? 1 : 0]));
                    }
                    else {
                        this.socket.send(`\x80\x01\x00`);
                    }
                },
            },
            {
                name: 'muteSet',
                regExp: /\x98\x03([\s\S])\x00([\s\S])/,
                callback: (match) => {
                    const muteIndex = match[1].charCodeAt(0);
                    if (muteIndex < 2) {
                        this.mute[muteIndex] = match[2].charCodeAt(0) === 1;
                        const mute = this.mute[muteIndex];
                        this.socket.send(this.makeCommand([0x98, 0x03, muteIndex, 0x00, mute ? 1 : 0]));
                    }
                    else {
                        this.socket.send(`\x80\x01\x00`);
                    }
                },
            },
            {
                name: 'standbyGet',
                regExp: /\xF0\x02\x72\x00/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0xf3, 0x02, 0x00, this.standbyMode ? 1 : 0]));
                },
            },
            {
                name: 'standbySet',
                regExp: /\xF3\x02\x00([\s\S])/,
                callback: (match) => {
                    this.standbyMode = match[1].charCodeAt(0) === 1;
                    this.socket.send(this.makeCommand([0xf3, 0x02, 0x00, this.standbyMode ? 1 : 0]));
                },
            },
            {
                name: 'volumeGet',
                regExp: /\xF0\x03\x11\x01\x00/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x91, 0x03, 0x01, 0x00, this.volume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x91\x03\x01\x00([\s\S])/,
                callback: (match) => {
                    this.volume = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x91, 0x03, 0x01, 0x00, this.volume]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(`\x80\x01\x00`);
                },
            },
        ];
    }
    makeCommand(data) {
        return AsciiText.decode(data);
    }
}
ToaAmCf1.emulatorType = 'socketEmulator';
ToaAmCf1.key = '-MZNXUJUJvvHoVzNxpTf';
